import { IconCalendarEvent, IconCash, IconChartBar, IconClock, IconFileText, IconHome, IconSquareCheck, IconUserPlus } from '@tabler/icons-react';
import type { NavGroup, NavItem } from '@hana/shell';
import { PEOPLE } from './data/fixtures';

// Menu chung của Hub cho HANA Mee (NAVK.sp.mee · board Mint-Mee / Mint-HR, QĐ anh David 01/Nov 12:33 · canvas 14:43):
// lớp CỦA TÔI (mọi nhân viên; "Duyệt đơn của nhóm" chỉ quản lý) + lớp NHÂN SỰ (chỉ ghế quản lý / HR / BOD, ẩn khi noperm).
// Mục NHÂN SỰ trỏ /mee/hr* (luồng J chuyển màn từ /ezy/hr*, 02/Nov; route cũ redirect).

const MINE: readonly NavItem[] = [
  { key: 'home', label: 'Tổng quan', to: '/mee', icon: IconHome },
  { key: 'time', label: 'Chấm công', to: '/mee/time', icon: IconClock },
  { key: 'leave', label: 'Nghỉ phép & đơn', to: '/mee/leave', icon: IconCalendarEvent, n: 3 },
  { key: 'pay', label: 'Lương', to: '/mee/pay', icon: IconCash },
  { key: 'docs', label: 'Hồ sơ & giấy tờ', to: '/mee/docs', icon: IconFileText, n: 2 },
  { key: 'grow', label: 'KPI & học tập', to: '/mee/grow', icon: IconChartBar, n: 2 },
  { key: 'approve', label: 'Duyệt đơn của nhóm', to: '/mee/approve', icon: IconSquareCheck, n: 4 },
];

const HR: readonly NavGroup[] = [
  {
    key: 'hr', label: 'Tổ chức & hồ sơ', icon: IconUserPlus, section: 'NHÂN SỰ',
    items: [
      { key: 'hr-ov', label: 'Tổng quan nhân sự', to: '/mee/hr' },
      { key: 'hr-staff', label: 'Nhân sự', to: '/mee/hr' },
      { key: 'hr-org', label: 'Cơ cấu & ghế', to: '/mee/hr' },
      { key: 'hr-profile', label: 'Hồ sơ', to: '/mee/hr/profile' },
      { key: 'hr-contract', label: 'HĐ lao động', to: '/mee/hr/contract' },
      { key: 'hr-decision', label: 'Quyết định', to: '/mee/hr/decision' },
      { key: 'hr-rec', label: 'Tuyển dụng', to: '/mee/hr' },
    ],
  },
  {
    key: 'cc', label: 'Chấm công & nghỉ', icon: IconClock,
    items: [
      { key: 'cc-time', label: 'Chấm công', to: '/mee/hr' },
      { key: 'cc-sheet', label: 'Ca làm & bảng công', to: '/mee/hr/attendance' },
      { key: 'cc-leave', label: 'Nghỉ phép & bàn giao', to: '/mee/hr' },
      { key: 'cc-ot', label: 'Làm thêm giờ', to: '/mee/hr' },
    ],
  },
  {
    key: 'lk', label: 'Lương & KPI', icon: IconCash,
    items: [
      { key: 'payroll', label: 'Bảng lương', to: '/mee/payroll' },
      { key: 'kpi', label: 'KPI', to: '/mee/hr/kpi' },
      { key: 'review', label: 'Đánh giá & mục tiêu', to: '/mee/hr/review' },
    ],
  },
];

/** Quản lý = như prop `role` của board (mgr / emp), không có thì theo hồ sơ người xem (`?viewer=`, mặc định DAVID). */
export function isManager(search: string): boolean {
  const p = new URLSearchParams(search);
  const role = p.get('role');
  if (role === 'mgr') return true;
  if (role === 'emp') return false;
  const viewer = p.get('viewer') ?? 'DAVID';
  return PEOPLE.find((x) => x.id === viewer)?.manager ?? false;
}

/** Menu theo người xem: nhân viên chỉ thấy CỦA TÔI (không Duyệt); quản lý thêm Duyệt + NHÂN SỰ; noperm bỏ số đếm và NHÂN SỰ. */
export function meeNav(search: string): { top: NavItem[]; nav: NavGroup[] } {
  const mgr = isManager(search);
  const noperm = new URLSearchParams(search).get('state') === 'noperm';
  const top = MINE.filter((i) => mgr || i.key !== 'approve').map((i) => (noperm ? { ...i, n: undefined } : { ...i }));
  return { top, nav: mgr && !noperm ? HR.map((g) => ({ ...g, items: [...g.items] })) : [] };
}

export const currentSearch = () => (typeof location === 'undefined' ? '' : location.search);
